import { render, staticRenderFns } from "./courseTmall.vue?vue&type=template&id=e56e7a64&scoped=true&"
import script from "./courseTmall.vue?vue&type=script&lang=js&"
export * from "./courseTmall.vue?vue&type=script&lang=js&"
import style0 from "./courseTmall.vue?vue&type=style&index=0&id=e56e7a64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56e7a64",
  null
  
)

export default component.exports